import KanbanFoldersAPI from '../../../api/kanbanFolders';
import { types } from './mutations';

export default {
  async fetchFolders({ commit }) {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const { data } = await KanbanFoldersAPI.getFolders();
      commit(types.SET_FOLDERS, data.data);
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },

  async createFolder({ commit }, folderData) {
    const { data } = await KanbanFoldersAPI.createFolder(folderData);
    commit(types.ADD_FOLDER, data);
    return data;
  },

  async updateFolder({ commit }, { id, ...folderData }) {
    const { data } = await KanbanFoldersAPI.updateFolder(id, folderData);
    commit(types.UPDATE_FOLDER, data);
    return data;
  },

  async deleteFolder({ commit }, id) {
    const { data } = await KanbanFoldersAPI.deleteFolder(id);
    commit(types.REMOVE_FOLDER, id);
    return data;
  },

  async reorderFolders({ commit }, ids) {
    await KanbanFoldersAPI.reorder(ids);
    const { data } = await KanbanFoldersAPI.getFolders();
    commit(types.SET_FOLDERS, data.data);
  },
};
